import cookies from "browser-cookies";
import uuidv1 from "uuid";
import { LDUser } from "launchdarkly-js-sdk-common";
import {
  STAGE_LOCAL,
  STAGE_TEST,
  STAGE_IMP,
  STAGE_PROD,
  getStage,
} from "./stageHelpers";
import { ProviderConfig } from "launchdarkly-react-client-sdk/lib/types";
import {
  LDClient,
  initialize as initializeLdClient,
} from "launchdarkly-js-client-sdk";

export const ldClientIds = {
  [STAGE_LOCAL]: "5b3bcba0598df85afec77ffa",
  [STAGE_TEST]: "5b3bcafb7288755ad8b53695",
  [STAGE_IMP]: "5b3bcb6b12122d5a2bf6aeed",
  [STAGE_PROD]: "5b3bcafb7288755ad8b53696",
};

export const ldOptions = {
  baseUrl: "https://app.launchdarkly.cms.gov",
  eventsUrl: "https://events.launchdarkly.cms.gov",
  streamUrl: "https://stream.launchdarkly.cms.gov",
  fetchGoals: false,
  sendLDHeaders: false,
};

export const getLdUser = (): LDUser => {
  const ldUserKey = cookies.get("mct-anonymous-session-id") || uuidv1();
  const mctOec2020 = cookies.get("mctOec2020");

  const ldUser: LDUser = {
    key: ldUserKey,
    anonymous: true,
    custom: {},
  };

  if (ldUser.custom && mctOec2020) {
    ldUser.custom["oec2020"] = mctOec2020;
  }

  return ldUser;
};

export const getLdClientId = (url = window.location.hostname): string =>
  ldClientIds[getStage(url)];

export const ldUser = getLdUser();

export const ldClientId = getLdClientId();

export const ldProviderConfig: ProviderConfig = {
  clientSideID: ldClientId,
  user: ldUser,
  options: ldOptions,
};

export const getLaunchDarklyClient = async (url: string): Promise<LDClient> => {
  const ldClient = initializeLdClient(getLdClientId(url), ldUser, ldOptions);

  return new Promise((resolve): void => {
    ldClient.on("ready", () => resolve(ldClient));
  });
};
